import { useState } from "react";
import { ButtonBase, Menu, MenuItem } from "@mui/material";

import getNameInitials from "utils/getNameInitials";
import useBoundStore from "store";
import AsyncAvatar from "components/AsyncAvatar";
import { StorageBuckets } from "api/storage";
import styles from "./avatarMenu.module.scss";

export interface AvatarMenuProps {
  onLogoutClick: () => void;
  onSettingsClick: () => void;
}

function AvatarMenu(props: AvatarMenuProps) {
  const { onLogoutClick, onSettingsClick } = props;
  const [anchorEl, setAnchorEl] = useState<(EventTarget & Element) | null>(null);
  const userProfile = useBoundStore((state) => state.user.profile);
  const smallAvatars = useBoundStore((state) => state.miscellaneous.smallAvatars);

  /**
   * Handle toggle menu
   *
   * @param event
   */
  const handleClick = (event: React.SyntheticEvent) => {
    setAnchorEl(event!.currentTarget);
  };

  /**
   * Handle close menu
   */
  const handleClose = () => {
    setAnchorEl(null);
  };

  /**
   * Handle settings click
   */
  const handleSettings = () => {
    handleClose();
    onSettingsClick();
  };

  /**
   * Handle logout click
   */
  const handleLogout = () => {
    handleClose();
    onLogoutClick();
  };

  return (
    <>
      <ButtonBase
        aria-controls='settings-menu'
        aria-haspopup='true'
        aria-label='User settings'
        onClick={handleClick}
        className={styles.avatar}
      >
        <AsyncAvatar
          avatarFile={userProfile?.avatar ? smallAvatars[userProfile.avatar] : undefined}
          avatarName={userProfile?.avatar}
          placeholder={getNameInitials(userProfile?.name ?? "")}
          bucket={StorageBuckets.PROFILES_AVATARS}
          preview={false}
        />
      </ButtonBase>

      <Menu
        id='settings-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem onClick={handleSettings}>Settings</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
    </>
  );
}

export default AvatarMenu;
